import React, { useMemo } from 'react';
import { Booth } from 'models/cms/booths';
import CMSMobileProfile from './templates/MobileProfile';
import BoothDesignMobileProfile from './boothDesign/MobileProfile';

export interface MobileProfileSwitchProps {
  booth: Booth;
}

const MobileProfileSwitch: React.FC<MobileProfileSwitchProps> = ({
  booth,
}: MobileProfileSwitchProps) => {
  const isV2Design = useMemo(() => !!booth.boothDesign?.id, [booth.boothDesign?.id]);

  return (
    isV2Design ? (
      <BoothDesignMobileProfile booth={booth} />
    ) : (
      <CMSMobileProfile booth={booth} />
    )
  );
};
export default MobileProfileSwitch;
